import { catalogApiFacade } from "@repo/api/catalog/client/server";
import { NoResultsDietsCarousel } from "@/features/diets/components/no-results-diets-carousel";

export const NoResultsDiets = async () => {
  const { data: recommendedDiets } =
    await catalogApiFacade.recommendedDiets.getList({
      next: { tags: ["recommended-diets"], revalidate: 3600 },
    });

  return <NoResultsDietsCarousel recommendedDiets={recommendedDiets} />;
};
